<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";
import SaveInfoEntry from "@/components/modals/cloud/SaveInfoEntry";

export default {
  name: "CloudLoadConflictModal",
  components: {
    ModalWrapperChoice,
    SaveInfoEntry,
  },
  computed: {
    conflict() {
      return this.$viewModel.modal.cloudConflict;
    },
    older() {
      return this.conflict.saveComparison.older === 1;
    },
    farther() {
      return this.conflict.saveComparison.farther === 1;
    },
    hasDifferentName() {
      return this.conflict.cloud.saveName !== this.conflict.local.saveName;
    },
    suggestionText() {
      const goodStyle = `style="color: var(--color-good)"`;
      const badStyle = `style="color: var(--color-bad)"`;

      const suggestions = ["Загрузка этого Облачного Сохранения "];
      const cloudProg = this.conflict.cloud.compositeProgress, localProg = this.conflict.local.compositeProgress;
      const warnOverwrite = this.farther && Math.abs(cloudProg - localProg) > 0.15;
      suggestions.push(warnOverwrite
        ? `<b ${badStyle}>приведёт к потере значительного количества прогресса локального сохранения</b>`
        : `<b ${goodStyle}>скорее всего безопасна</b>`);
      if (this.hasDifferentName) {
        suggestions.push(`<br>${warnOverwrite ? "Дополнительно," : "Однако"} Облачное сохранение
          <b ${badStyle}>может быть сохранением с другого устройства</b>.`);
      }
      if (warnOverwrite || this.hasDifferentName) {
        suggestions.push(`<br><b ${badStyle}>Вы уверены, что хотите перезаписать ваше локальное сохранение?</b>`);
      }
      return suggestions.join("");
    }
  },
  methods: {
    confirm() {
      this.conflict.onAccept?.();
      EventHub.dispatch(GAME_EVENT.CLOSE_MODAL);
    }
  }
};
</script>

<template>
  <ModalWrapperChoice
    class="c-modal-options__large"
    :cancel-class="'c-modal-message__okay-btn'"
    :confirm-class="'c-modal-message__okay-btn c-modal__confirm-btn'"
    :confirm-fn="confirm"
  >
    <template #header>
      Загрузить Игру с Облака
    </template>
    <span v-if="hasDifferentName">
      Ваши Локальное и Облачное сохранения имеют <b>разные имена</b>.
    </span>
    <span v-else-if="older">
      Загрузка с Облака <b>загрузит сохранение с меньшим игровым временем</b>.
    </span>
    <span v-else-if="farther">
      Загрузка с Облака <b>привёдет к потере прогресса</b>.
    </span>
    <span v-else>
      Кажется, что ваши Локальное и Облачное сохранения <b>имеют примерно одинаковое количество прогресса</b>.
    </span>
    Пожалуйста выберите сохранение, которое хотите загрузить.
    <br>
    <br>
    <SaveInfoEntry
      :save-data="conflict.local"
      :other-data="conflict.cloud"
      :save-id="conflict.saveId"
      :show-name="hasDifferentName"
      save-type="Локальное Сохранение"
    />
    <SaveInfoEntry
      :save-data="conflict.cloud"
      :other-data="conflict.local"
      :save-id="conflict.saveId"
      :show-name="hasDifferentName"
      save-type="Облачное Сохранение"
    />
    <span v-html="suggestionText" />
    <template #cancel-text>
      Оставить Локальное Сохранение
    </template>
    <template #confirm-text>
      Перезаписать Локальное Сохранение Облачным
    </template>
  </ModalWrapperChoice>
</template>